import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
	TVatReimbursementsData,
	TVatReimbursementsRequest,
	TVatReimbursementState,
	TReceiveVatReimbursementRequest,
	TUpdateCommentRequest,
} from './types';

const initialState: TVatReimbursementState = {
	vatReimbursements: null,
	vatReimbursementsLoading: false,
	receiveVatReimbursementLoading: false,
	updateCommentLoading: false,
};

const vatReimbursement = createSlice({
	name: '@@vatReimbursement',
	initialState,
	reducers: {
		getVatReimbursementsRequest: (
			state: TVatReimbursementState,
			action: PayloadAction<TVatReimbursementsRequest>,
		) => {
			const vatReimbursementState = state;
			vatReimbursementState.vatReimbursementsLoading = true;
			// vatReimbursementState.vatReimbursements = null;
		},
		getVatReimbursementsSuccess: (
			state: TVatReimbursementState,
			action: PayloadAction<TVatReimbursementsData>,
		) => {
			const vatReimbursementState = state;
			vatReimbursementState.vatReimbursements = action.payload;
			vatReimbursementState.vatReimbursementsLoading = false;
		},
		receiveVatReimbursementRequest: (
			state: TVatReimbursementState,
			action: PayloadAction<TReceiveVatReimbursementRequest>,
		) => {
			const vatReimbursementState = state;
			vatReimbursementState.receiveVatReimbursementLoading = true;
		},
		receiveVatReimbursementSuccess: (
			state: TVatReimbursementState,
			action: PayloadAction<TVatReimbursementsData>,
		) => {
			const vatReimbursementState = state;
			vatReimbursementState.receiveVatReimbursementLoading = false;
		},
		updateCommentRequest: (
			state: TVatReimbursementState,
			action: PayloadAction<TUpdateCommentRequest>,
		) => {
			const vatReimbursementState = state;
			vatReimbursementState.updateCommentLoading = true;
		},
		updateCommentSuccess: (
			state: TVatReimbursementState,
			action: PayloadAction<TVatReimbursementsData>,
		) => {
			const vatReimbursementState = state;
			vatReimbursementState.updateCommentLoading = false;
		},
	},
});

export default vatReimbursement.reducer;
export const {
	getVatReimbursementsRequest,
	getVatReimbursementsSuccess,
	receiveVatReimbursementRequest,
	receiveVatReimbursementSuccess,
	updateCommentRequest,
	updateCommentSuccess,
} = vatReimbursement.actions;
